// Numbers

const percentage = (value) => {
  if (typeof value === "number") {
    const pValue = (value * 100).toFixed(0).toString();
    return `${pValue.split(".")[0]}%`;
  }
  return value;
};

const percentageNoRound = (value) => {
  if (typeof value === "number") {
    let pValue = (value * 100).toFixed(2);
    if (pValue === 0) return "0%";
    if (pValue >= 99) return "99%";
    return `${pValue}%`;
  }
  return value;
};

const round = (value, precision = 3) => {
  if (typeof value === "number") {
    const factor = Math.pow(10, precision);
    return Math.round(value * factor) / factor;
  }
  return value;
};

// https://stackoverflow.com/a/2901298
const commas = (x) => {
  if (typeof x !== "undefined") {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
};

const money = (value) => {
  if (!value) return "";
  /* eslint-disable-next-line */
  value = value.toFixed(0);
  return "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Strings

const capitalize = (value) => {
  if (!value) return "";
  return value.toLowerCase().replace(/(^| )(\w)/g, (s) => s.toUpperCase());
};

const change = (value) => {
  if (value <= 0) {
    return value.toString();
  } else {
    return `+${value}`;
  }
};

const margin = (v) => {
  let value = v.toString();
  if (value === "0") {
    value = "Even";
  } else if (value.includes("-")) {
    value = value.replace("-", "");
    value = "D+" + value;
  } else {
    value = "R+" + value;
  }
  return value;
};

const partyLabel = (value) => {
  if (!value) return "";
  if (value === "Democratic") {
    return "DEM";
  } else if (value === "Republican") {
    return "GOP";
  } else if (value === "Libertarian") {
    return "LIB";
  } else if (value === "Green") {
    return "GRE";
  } else if (value === "Nonpartisan") {
    return "NPA";
  } else if (value === "Progressive") {
    return "PROG";
  } else if (value === "Independent") {
    return "IND";
  } else if (value === "United Utah") {
    return "UU";
  } else if (value === "Constitution") {
    return "CONST";
  } else if (value === "United Citizens") {
    return "UCP";
  } else {
    return "OTH";
  }
};

const partyAbbrev = (value) => {
  if (!value) return "";
  if (value === "Democratic") {
    return "D";
  } else if (value === "Republican") {
    return "R";
  } else if (value === "Libertarian") {
    return "L";
  } else if (value === "Green") {
    return "G";
  } else if (value === "Nonpartisan") {
    return "Nonpartisan";
  } else {
    return "Other";
  }
};

const votePercent = (value) => {
  if (!value) return "";
  let perc = (value * 100).toFixed(2);
  if (perc > 99 && perc < 100) {
    perc = "> " + 99;
  } else if (perc > 0 && perc < 1) {
    perc = "< " + 1;
  }
  return perc + "%";
};

export {
  capitalize,
  change,
  commas,
  margin,
  money,
  partyLabel,
  partyAbbrev,
  percentage,
  percentageNoRound,
  round,
  votePercent,
};
